module.exports = __webpack_public_path__ + "site/img/35.633dbbe8.jpg";